import { produce } from 'immer';
import { Store, StoreConfig } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { IShowAllState } from './show-all.interface';
import { Consts } from '@shared/consts';

export function createInitialState(): IShowAllState {
    return {
        hasFullOrdersVisibility: false,
        isShowAllToggleEnabled: false,
        doctorsMap: {}
    };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: Consts.ShowAllStore, producerFn: produce })
export class ShowAllStore extends Store<IShowAllState> {
    constructor() {
        super(createInitialState());
    }
}
